import * as React from 'react';
import ItemSaveContainer from '@/components/ItemSave/ItemSaveContainer';

type Props = {
    itemId: number;
};

const ItemBiddingSaveButton = ({ itemId }: Props) => {
    return <ItemSaveContainer button itemId={itemId} showSavedCount />;
};

export default React.memo<Props>(ItemBiddingSaveButton);
